import AlertsButton from './AlertsButton';

export default AlertsButton;
